import * as React from 'react';
import { PropTypes } from 'prop-types';
import { Navigate } from 'react-router-dom';
import { PAGE_PATHS } from '../constants/page-paths';

export const PrivateRoute = ({
  children,
  isUserLoggedIn = undefined,
  redirectTo = PAGE_PATHS.LOGIN,
}) => {
  if (isUserLoggedIn === undefined) return null;
  if (isUserLoggedIn === false){
    const redirectPath =
      window.location.pathname +
      window.location.search +
      window.location.hash;
    localStorage.setItem('redirectAfterLogin', redirectPath);
    return <Navigate to={redirectTo} replace />;
  } 
  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node,
  isUserLoggedIn: PropTypes.bool,
  redirectTo: PropTypes.string,
};
